import axios from 'axios';
import { handleError, handleResponse } from '../utils/ServideHelper';

require('dotenv').config();

const urlDadoMestre = process.env.REACT_APP_URLDADOMESTRE || '/dadomestre';
const urlComunicaErp = process.env.REACT_APP_URLCOMUNICAERP || '/comunicaerp';
const urlGatewayAuthorization = process.env.REACT_APP_GATEWAY_URL_AUTHORIZATIONS || '/authorizations';

export const getAuthorizations = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlGatewayAuthorization}`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getFornecedores = query => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/fornecedores?filter=${encodeURIComponent(query)}`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getPvs = (date, id_processo, calendario) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/pvs?data=${date}&id=${id_processo}&calendario=${calendario}`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getFavoritos = login => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/fornecedores/favoritos/${login}`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getFeriados = (inicio, fim) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/capacidade/feriados?inicio=${inicio}&fim=${fim}`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const salvaFavoritos = (id, data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/fornecedores/favoritos/${id}`,
            data: data,
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getInspecaoDetalhada = pedidos => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/save-log/get-logs`,
            data: { pedidos },
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getCapacidades = data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/capacidades`,
            data,
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const sendTriagens = data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/triagem`,
            data,
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getDesempenho = data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/desempenho`,
            data,
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getJustificativa = data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/get-justificativas`,
            data,
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getAllPvs = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/all-pvs`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getSemanas = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/semanas`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getSupervisoras = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/supervisoras`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getIndiceQualidade = data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/indice-qualidade`,
            data,
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getPedidos = data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/pedidos/`,
            data: data,
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getAmostragemTotal = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/qualidade/amostratotal`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getAmostragem = (tipo, pecas) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/qualidade/amostragem?tipo=${tipo}&pecas=${pecas}`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getDefeitos = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/defeitos`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const geraNotaQM = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/notaqm`,
            method: 'post',
            data: { data },
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const geraNotaQMTemp = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/notaqm-tmp`,
            method: 'post',
            data: { data },
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const setNotaQM = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/qualidade/notaqm`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getNotaQM = query => {
    if (!query) query = '';
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/qualidade/notaqm?pedido=${query}`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const setFoto = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/foto`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getObservacoes = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/faccao/observacoes`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};
export const getJustificativas = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/faccao/justificativas`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getStatus = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/faccao/status`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const setAuditoria = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/auditoria`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const setAuditoriaUpdateTempTable = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/auditoria-tmp`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

/** SET ADMIN */

export const setAmostragem = async data => {
    console.log('seta amostragem', data);
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/qualidade/amostragem`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const setObservacoes = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/faccao/observacoes`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const setJustificativas = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/faccao/justificativas`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const saveStatus = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlDadoMestre}/faccao/status`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const postJustificativa = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/justificativas`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getNos = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/get-no`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getRoteiro = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/get-roteiro`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};
export const getListaCritica = async data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/get-lista-critica`,
            method: 'post',
            data,
            maxContentLength: Infinity,
        };
        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};

export const getProdutividade = data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/produtividade`,
            data,
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};
export const getTriangulacao = data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/triangulacao`,
            data,
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};
export const getTriangulacaoQualidade = data => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `${urlComunicaErp}/sap/triangulacao-qualidade`,
            data,
            method: 'post',
            maxContentLength: Infinity,
        };

        axios(config)
            .then(handleResponse(resolve))
            .catch(handleError(reject));
    });
};
